(() => {
  const initializeDock = (dock) => {
    const sectionId = dock.dataset.productSection;
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`);
    const sourceButton = productInfo?.querySelector('.product-form__submit');
    const dockButton = dock.querySelector('[data-bird-dock-add]');
    const dockPrice = dock.querySelector('[data-bird-dock-price]');
    const dockVariant = dock.querySelector('[data-bird-dock-variant]');

    if (!productInfo || !sourceButton || !dockButton) return;

    const updateDock = () => {
      const selectedValues = [...productInfo.querySelectorAll('variant-selects [data-selected-value]')]
        .map((value) => value.textContent.trim())
        .filter(Boolean);
      const salePrice = productInfo.querySelector('.price-item--sale');
      const regularPrice = productInfo.querySelector('.price-item--regular');
      const currentPrice = salePrice?.textContent.trim() || regularPrice?.textContent.trim();

      if (dockVariant && selectedValues.length) dockVariant.textContent = selectedValues.join(' · ');
      if (dockPrice && currentPrice) dockPrice.textContent = currentPrice;
      dockButton.disabled = sourceButton.disabled;
      dockButton.textContent = sourceButton.disabled ? sourceButton.textContent.trim() : 'Add to cart';
    };

    const sourceObserver = new IntersectionObserver(
      ([entry]) => {
        const hasPassedSourceButton = entry.boundingClientRect.bottom <= 0;
        dock.dataset.visible = String(!entry.isIntersecting && hasPassedSourceButton);
      },
      { threshold: 0.2 }
    );

    sourceObserver.observe(sourceButton);
    productInfo.addEventListener('change', () => window.setTimeout(updateDock, 0));
    new MutationObserver(updateDock).observe(productInfo, { childList: true, subtree: true, characterData: true });
    dockButton.addEventListener('click', () => sourceButton.click());
    updateDock();
  };

  const initializeSizeChartLink = (link) => {
    if (link.dataset.birdSizeChartInitialized === 'true') return;

    link.dataset.birdSizeChartInitialized = 'true';
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');
      const target = targetId ? document.querySelector(targetId) : null;
      const details = target?.matches('details') ? target : target?.querySelector('details');
      const summary = details?.querySelector('summary');

      if (!target || !details || !summary) return;

      event.preventDefault();
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center',
      });
      summary.focus({ preventScroll: true });
      window.history.replaceState(null, '', targetId);
    });
  };

  const initialize = () => {
    document.querySelectorAll('[data-bird-product-dock]').forEach(initializeDock);
    document.querySelectorAll('.bird-size-chart-link').forEach(initializeSizeChartLink);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
